var templateUrl = require('./denied.html');

angular.module('ciApp').component('denied', {
  templateUrl: templateUrl,
  controller: [DeniedController]
});

function DeniedController() {}



// WEBPACK FOOTER //
// ./app/denied/denied.component.js